module.exports = __webpack_public_path__ + "static/media/upload-csv.65ab841c.svg";